import styled, { css } from 'styled-components';
import FluffyCard from '@gotamedia/fluffy/Card';
import { tint } from 'polished';
import { Link } from '@remix-run/react';
import { themeHelpers } from '@gotamedia/fluffy/theme';
import Icon from '@gotamedia/fluffy/Icon';
const Card = styled(FluffyCard).withConfig({
  displayName: "style__Card",
  componentId: "sc-1tysra-0"
})(["border-radius:0;min-height:220px;&:hover{cursor:pointer;background:#f2f2f2;}"]);
const BrokenCardImage = styled.img.withConfig({
  displayName: "style__BrokenCardImage",
  componentId: "sc-1tysra-1"
})(["width:25px;height:25px;margin:auto;"]);
const Flex = styled.div.withConfig({
  displayName: "style__Flex",
  componentId: "sc-1tysra-2"
})(["flex:1;display:flex;flex-direction:row;"]);
const ImageWrapper = styled.div.withConfig({
  displayName: "style__ImageWrapper",
  componentId: "sc-1tysra-3"
})(["padding:12px;position:relative;", ""], ({
  $overflow
}) => $overflow && css(["         &:after{content:\"\";width:100%;height:100%;position:absolute;background:linear-gradient(rgba(255,255,255,0) 0%,rgba(255,255,255,0.5) 80%,rgb(255,255,255) 100%);top:0;right:0;bottom:0;left:0;}"]));
const StyledLink = styled(Link).withConfig({
  displayName: "style__StyledLink",
  componentId: "sc-1tysra-4"
})(["width:calc(50% - 10px);", ""], themeHelpers.isSmallDevice(css(["width:100%;"])));
const TextLink = styled.p.withConfig({
  displayName: "style__TextLink",
  componentId: "sc-1tysra-5"
})(["color:", ";text-decoration:underline;"], ({
  theme
}) => theme.colors.link);
const CardContainer = styled.div.withConfig({
  displayName: "style__CardContainer",
  componentId: "sc-1tysra-6"
})(["display:flex;flex-direction:row;margin:5px;padding:5px;max-width:1250px;width:100%;&:hover{background-color:", ";}"], ({
  theme
}) => tint(0.85, theme.colors.brand));
const ImageContainer = styled.div.withConfig({
  displayName: "style__ImageContainer",
  componentId: "sc-1tysra-7"
})(["display:flex;max-width:104px;height:77px;width:100%;flex-direction:column;background-color:", ";"], ({
  theme
}) => theme.colors.grey[4]);
const Image = styled.img.withConfig({
  displayName: "style__Image",
  componentId: "sc-1tysra-8"
})(["height:146px;object-fit:contain;max-width:220px;margin-right:20px;", ""], themeHelpers.isSmallDevice(css(["max-width:200px;margin-right:10px;"])));
const InfoContainer = styled.div.withConfig({
  displayName: "style__InfoContainer",
  componentId: "sc-1tysra-9"
})(["display:flex;flex-direction:column;"]);
const DetailContainer = styled.div.withConfig({
  displayName: "style__DetailContainer",
  componentId: "sc-1tysra-10"
})(["display:flex;flex-direction:column;", ""], themeHelpers.isSmallDevice(css(["flex-direction:column;"])));
const DetailInfoContainer = styled.div.withConfig({
  displayName: "style__DetailInfoContainer",
  componentId: "sc-1tysra-11"
})(["display:flex;flex-direction:row;align-items:center;margin:3px 0;"]);
const Text = styled.span.withConfig({
  displayName: "style__Text",
  componentId: "sc-1tysra-12"
})([""]);
const StyledIcon = styled(Icon).withConfig({
  displayName: "style__StyledIcon",
  componentId: "sc-1tysra-13"
})(["margin-right:8px;"]);
const Headline = styled.div.withConfig({
  displayName: "style__Headline",
  componentId: "sc-1tysra-14"
})(["display:flex;flex-direction:column;"]);
const SubHeadline = styled.p.withConfig({
  displayName: "style__SubHeadline",
  componentId: "sc-1tysra-15"
})(["font-weight:700;font-size:16px;line-height:20px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-family:\"Sanomat Sans\";"]);
const CardImage = styled(Card.Image).withConfig({
  displayName: "style__CardImage",
  componentId: "sc-1tysra-16"
})(["width:100%;height:100%;aspect-ratio:2/3;position:relative;", ""], ({
  $overflow
}) => $overflow && css(["object-fit:cover;object-position:top;"]));
export { StyledLink, Headline, SubHeadline, BrokenCardImage, Text, CardContainer, InfoContainer, ImageContainer, DetailContainer, DetailInfoContainer, Card, Image, Flex, ImageWrapper, StyledIcon, CardImage, TextLink };